<template>
  <div class="row m-0">
    <Loader
      v-if="showLoader"
    />
    <ResearchNavigation
      :research-name="research.campaign_name"
    />
    <Container>
      <div
        v-if="research.campaign_result"
        class="d-flex flex-column"
      >
        <Result
          v-if="research.campaign_result"
          :data="research.campaign_result"
        />
      </div>

      <Questions
        v-if="step == 3"

        v-model="research.campaign_questions"
        :is-submitted="research.status >= 2"

        @submitted="submitResearchQuestions(); step = 4;"
      />

      <FacebookAds
        v-if="step == 4"

        v-model="research.campaign_ad"
        @created="createFacebookAds();"
      />

      <div v-if="step == 5">
        Ads created!
      </div>
    </Container>
    <Sidebar id="selection-sidebar">
      <div class="px-4">
        <div class="my-4 py-3">
          <h5 class="py-2">
            CLUSTERS
          </h5>
          <p>
            <small>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua.
            </small>
          </p>
        </div>
      </div>
    </Sidebar>
  </div>
</template>
<script>
import ResearchNavigation from '@/components/sidebars/ResearchNavigation.vue';
import Container from '@/components/core/Container.vue';
import Sidebar from '@/components/core/Sidebar.vue';
import Result from '@/containers/research/modules/Result.vue';
import Questions from '@/containers/research/modules/Questions.vue';
import FacebookAds from '@/containers/research/modules/FacebookAds.vue';

import API from '@/services/';
import { API_RESEARCH } from '@/helpers/config';

export default {
  components: {
    ResearchNavigation,
    Container,
    Sidebar,
    Result,
    Questions,
    FacebookAds,
  },
  data() {
    return {
      showLoader: true,
      step: 1,
      research: {
        campaign_name: '',
        campaign_details: {
          category: null,
          sub_category: null,
          marketing_hooks: [],
          how_it_feels: [],
          age_min: 13,
          age_max: 65,
          genders: 0,
          life_stage: [],
        },
        campaign_questions: [],
        campaign_result: null,
      },
    };
  },
  created() {
    this.getResearchDetails();
  },
  methods: {
    getResearchDetails() {
      API.get(`${API_RESEARCH}/${this.$route.params.id}`)
        .then((response) => {
          this.research = response.data.data;
          this.step = 1;
          this.showLoader = false;
        }).catch((err) => {
          this.$snotify.error(err.message);
          this.$router.push('/');
        });
    },
    updateResearch() {
      this.research.campaign_result = null;

      API.put(
        `${API_RESEARCH}/${this.$route.params.id}`,
        this.research,
      )
        .then(() => {
          this.getResearchDetails();
        }).catch((err) => {
          this.$snotify.error(err.message);
          this.$router.push('/');
        });
    },
    refineResearch() {
      this.research.campaign_result = null;

      API.put(
        `${API_RESEARCH}/${this.$route.params.id}/detail`,
        this.research.campaign_details,
      )
        .then(() => {
          this.getResearchDetails();
        });
    },
    submitResearchQuestions() {
      API.put(
        `${API_RESEARCH}/${this.$route.params.id}/question`,
        this.research.campaign_questions,
      );
    },
    createFacebookAds() {
      API.put(
        `${API_RESEARCH}/${this.$route.params.id}/ad`,
        this.research.campaign_ad,
      ).then(() => {
        this.step = 5;
      });
    },
  },
};
</script>
<style>
  .tran {
    transition: 0.5s ease all;
  }

  .sub {
    position: absolute!important;
    top: 0;
    right: -50%;
    transition: 0.5s ease all;
  }

  .sub.active {
    right: 0;
  }

  .research-next-button {
    margin-top: 30px;
    margin-left: auto;
    margin-right: -15px;
  }

  .right-button {
    margin-left: auto;
  }
</style>
